import { setStorageEventListeners } from "./storage";

export function setAllWindowEventListener() {
  setStorageEventListeners();
}
